import { render, staticRenderFns } from "./GuiaPasos.vue?vue&type=template&id=a40d9d8e&scoped=true"
import script from "./GuiaPasos.vue?vue&type=script&lang=ts"
export * from "./GuiaPasos.vue?vue&type=script&lang=ts"
import style0 from "./GuiaPasos.vue?vue&type=style&index=0&id=a40d9d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40d9d8e",
  null
  
)

export default component.exports